import { useState } from "react";
import { Employee, EmployeeEvaluation } from "@/types/employee";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { EmployeeHRDetail } from "@/components/EmployeeHRDetail";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

interface EmployeeDetailProps {
  employee: Employee;
  evaluations: EmployeeEvaluation[];
}

const EmployeeDetail = ({ employee, evaluations }: EmployeeDetailProps) => {
  const navigate = useNavigate();
  const { userRole, profile } = useAuth();
  const isEmployee = userRole === 'employee';
  const isOwnProfile = profile?.employee_id === employee.id;

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
        {/* Hide back button for employees viewing their own profile - they don't need to go to employee list */}
        {!(isEmployee && isOwnProfile) && (
          <Button variant="outline" size="icon" onClick={() => navigate("/employees")} className="flex-shrink-0">
            <ArrowLeft className="h-4 w-4" />
          </Button>
        )}
        <div className="flex-1 min-w-0">
          <h2 className="text-2xl sm:text-3xl font-bold text-foreground break-words">{employee.name}</h2>
          <p className="text-sm sm:text-base text-muted-foreground mt-1 break-words">{employee.position} • Nr. {employee.employeeNumber}</p>
        </div>
      </div>

      {/* HR Data Tabs - includes evaluation history */}
      <EmployeeHRDetail employeeId={employee.id} employeeName={employee.name} />
    </div>
  );
};

export default EmployeeDetail;
